import { api } from '@/plugins/axios'

const API_BASE_V1 = process.env.VUE_APP_API_BASE_V1
const EARLY_ADMISSION_BASE = `${API_BASE_V1}/early-admission`

/**
 * Enroll a student early (with temporary roll number)
 */
const enrollStudentEarly = async request => {
  const res = await api.post(`${EARLY_ADMISSION_BASE}/enroll`, request)

  return res
}

/**
 * Get next admission number (institution-wide)
 */
const getNextAdmissionNumber = async institutionId => {
  const res = await api.get(`${EARLY_ADMISSION_BASE}/next-admission-number`, { params: { institutionId } })

  return res
}

/**
 * Get students with temporary roll numbers for a batch
 */
const getStudentsWithTemporaryRollNumbers = async (institutionId, batchId) => {
  const res = await api.get(`${EARLY_ADMISSION_BASE}/temporary-roll-numbers`, { params: { institutionId, batchId } })

  return res
}

/**
 * Get students for roll number assignment (by class-section)
 */
const getStudentsForRollAssignment = async (institutionId, batchId, classId, section) => {
  const res = await api.get(`${EARLY_ADMISSION_BASE}/for-roll-assignment`, { params: { institutionId, batchId, classId, section } })

  return res
}

/**
 * Assign final roll numbers (replaces temporary ones)
 */
const assignFinalRollNumbers = async request => {
  const res = await api.post(`${EARLY_ADMISSION_BASE}/assign-roll-numbers`, request)

  return res
}

/**
 * Auto-assign final roll numbers
 */
const autoAssignFinalRollNumbers = async (institutionId, batchId, classId, section, sortBy = 'admissionNumber') => {
  const res = await api.post(`${EARLY_ADMISSION_BASE}/auto-assign-roll-numbers`, null, { params: { institutionId, batchId, classId, section, sortBy } })

  return res
}

/**
 * Update provisional class/section for a student
 */
const updateProvisionalAssignment = async (studentId, provisionalClassId, provisionalSection) => {
  const res = await api.put(`${EARLY_ADMISSION_BASE}/${studentId}/provisional-assignment`, null, { params: { provisionalClassId, provisionalSection } })

  return res
}

/**
 * Get roll number status for a batch
 */
const getRollNumberStatus = async (institutionId, batchId) => {
  const res = await api.get(`${EARLY_ADMISSION_BASE}/roll-number-status`, { params: { institutionId, batchId } })

  return res
}

/**
 * Activate batch (with optional auto-assignment of roll numbers)
 */
const activateBatch = async (institutionId, batchId, autoAssignRollNumbers = true) => {
  const res = await api.post(`${EARLY_ADMISSION_BASE}/activate-batch`, null, { params: { institutionId, batchId, autoAssignRollNumbers } })

  return res
}

/**
 * Step 1: Create classes for new batch (for provisional admission setup)
 */
const createClassesForNewBatch = async (institutionId, oldBatchId, newBatchId) => {
  const res = await api.post(`${EARLY_ADMISSION_BASE}/setup/step1/create-classes`, null, { params: { institutionId, oldBatchId, newBatchId } })

  return res
}

/**
 * Step 2: Copy class fees to new batch (for provisional admission setup)
 */
const copyClassFeesForProvisionalAdmission = async (institutionId, oldBatchId, newBatchId) => {
  const res = await api.post(`${EARLY_ADMISSION_BASE}/setup/step2/copy-class-fees`, null, { params: { institutionId, oldBatchId, newBatchId } })

  return res
}

/**
 * Complete provisional admission setup (creates classes and copies fees)
 */
const setupProvisionalAdmission = async request => {
  const res = await api.post(`${EARLY_ADMISSION_BASE}/setup/complete`, request)

  return res
}

export const earlyAdmissionApi = {
  enrollStudentEarly,
  getNextAdmissionNumber,
  getStudentsWithTemporaryRollNumbers,
  getStudentsForRollAssignment,
  assignFinalRollNumbers,
  autoAssignFinalRollNumbers,
  updateProvisionalAssignment,
  getRollNumberStatus,
  activateBatch,
  createClassesForNewBatch,
  copyClassFeesForProvisionalAdmission,
  setupProvisionalAdmission,
}
